/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, FC, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { PDFLinkCard } from '../../../../../../_metronic/partials/content/cards/PDFLinkCard'
import { PublicationModel } from '../../../../auth'
import { getPDFURL, listRecentArticle } from '../../../../auth/core/_api'
import ReactPaginate from 'react-paginate';
import ReactDOM from "react-dom/client";
import React from "react";

// Example items, to simulate fetching from another resources.
var items:Array<number> = [];
var item_per_page = 4

function Items({ currentItems }: any) {
    return (
        <>
            {currentItems &&
                currentItems.map((item: any) => (
                    <div>
                        <h3>Item #{item}</h3>
                    </div>
                ))}
        </>
    );
}


const RecentPublication: FC<{ personType: string, majorID: string, degreeID: string, search: string}> = ({ personType, majorID, degreeID, search}) => {
    const [publications, setPublication] = useState<PublicationModel[]>()
    const [itemOffset, setItemOffset] = useState(0);

    function PaginatedItems({ itemsPerPage }: any) {
        const endOffset = itemOffset + itemsPerPage;
        console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        const currentItems = items.slice(itemOffset, endOffset);
        const pageCount = Math.ceil(items.length / itemsPerPage);
    
        const handlePageClick = async (event: any) => {
            const newOffset = (event.selected * itemsPerPage) % items.length;
            console.log(
                `User requested page number ${event.selected}, which is offset ${newOffset}}`
            );
            setItemOffset(newOffset);

            const publications = await listRecentArticle(personType, majorID, degreeID, search, event.selected * item_per_page, newOffset)
                var publication_arr = new Array<PublicationModel>()
                publications.data.articles.forEach((publication: PublicationModel) => {
                    publication_arr.push(publication)
                });
                setPublication(publication_arr)
        };
    
        return (
            <>
                {/*<div className='w-100'>
                    <Items currentItems={currentItems} />
                </div> */}
    
                <div className='w-100'>
                    <ReactPaginate
                        previousLabel="ก่อนหน้า"
                        previousClassName="me-2 pt-1"
                        nextLabel="ถัดไป"
                        nextClassName="ms-2 pt-1"
                        breakLabel="..."
                        pageLinkClassName="page-link"
                        pageClassName="page"
                        breakClassName={""}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageCount={pageCount} />
                </div>
            </>
        );
    }

    useEffect(() => {
        async function updatePersonalPublication() {
            try {
                const publications = await listRecentArticle(personType, majorID, degreeID, search, 0, item_per_page)
                //alert('search: '+search)
                var publication_arr = new Array<PublicationModel>()
                publications.data.articles.forEach((publication: PublicationModel) => {
                    publication_arr.push(publication)
                });
                var aritcle_num = publications.data.aritcle_num
                var articles:Array<number> = []
                if(aritcle_num){
                    for(var i=0; i<aritcle_num; i++){
                        articles.push(i)
                    }
                    items = articles
                }
                console.log("aritcle_num: "+aritcle_num)
                setPublication(publication_arr)

                const root = ReactDOM.createRoot(document.getElementById("container") as HTMLElement);
                root.render(
                <React.StrictMode>
                    <PaginatedItems itemsPerPage={item_per_page} />
                </React.StrictMode>
                );

            } catch (error) {
                //setLoading(false)
            }
        };
        updatePersonalPublication()

    }, [personType, majorID, degreeID, search]);

    return (
        <>
            <div className='mb-10'>
                {publications && publications.map((item, i) => {
                    return (
                        <Fragment key={`question_${i}`}>
                            <div className='mb-0'>
                                <div className='d-flex align-items-center mb-4'>
                                    <Link
                                        //to='/apps/devs/question'
                                        to={`/home/article?doc_type=${item.doc_type}`}
                                        className='fs-2 fw-bolder text-gray-900 text-hover-primary me-1'
                                    >
                                        {item.title}
                                    </Link>
                                </div>

                                <div className='fs-base fs-3 text-gray-700 mb-4'>{item.description && item.description.substring(0, 250)}</div>

                                <div className='d-flex flex-stack flex-wrap'>
                                    <div className='d-flex align-items-center py-1'>
                                        <div className='symbol symbol-35px me-2'>
                                            <PDFLinkCard icon='/media/svg/files/pdf.svg' title='View' url={`${getPDFURL(item.pdf_file)}`} />
                                        </div>

                                        <div className='d-flex flex-column align-items-start justify-content-center'>
                                            <span className='text-gray-900 fs-7 fw-bold lh-1 mb-2'>{item.doc_type}</span>
                                            <span className='text-muted fs-7 lh-1 mb-2'>{item.degree_name}</span>
                                            <span className='text-muted fs-8 fw-bold lh-1'>{item.date}</span>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-center py-1'>
                                        <Link
                                            to={`/home/article?pid=${item.id}`}
                                            className='btn btn-sm btn-outline btn-outline-dashed btn-outline-primary px-4 me-2'
                                        >
                                            แสดงรายละเอียด <i className="ms-1 bi bi-arrow-right-circle"></i>
                                        </Link>

                                    </div>
                                </div>
                            </div>{' '}
                            <div className='separator separator-dashed border-gray-300 my-8'></div>
                        </Fragment>
                    )
                })}

                {
                    publications && publications.length == 0 && <span className='fs-2 text-danger'>ไม่พบรายการที่ค้นหา</span>
                }
            </div>

            <div id='container' className='d-flex flex-center mb-0'>
                {/* to be rendered by program */}
            </div>
        </>
    )
}

export { RecentPublication }
